import { useMemo } from 'react';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import type { ICheckoutContext } from '@/types/context';
import { resolveNuveiWalletConfig } from '@/utils/nuvei';

type NuveiWalletPaymentMethod = PaymentMethodEnum.APPLE_PAY | PaymentMethodEnum.GOOGLE_PAY;

export const useNuveiWalletSettings = (
  paymentMethodName: NuveiWalletPaymentMethod,
  paymentKeys: ICheckoutContext['paymentKeys'],
  paymentMethodsSettings: ICheckoutContext['paymentMethodsSettings']
) => {
  const providerSettings = useMemo(
    () =>
      paymentMethodsSettings.find(
        (paymentMethod) =>
          paymentMethod.paymentMethodName === paymentMethodName && paymentMethod.provider === ProviderEnum.NUVEI
      ),
    [paymentMethodName, paymentMethodsSettings]
  );

  const nuveiConfig = useMemo(
    () => resolveNuveiWalletConfig(paymentKeys.nuvei, providerSettings?.publicConfig),
    [paymentKeys.nuvei, providerSettings?.publicConfig]
  );

  return { providerSettings, nuveiConfig };
};
